document.addEventListener('DOMContentLoaded', () => {
  const wrappersMap = new Map();

  const getGalleryContainer = () =>
    document.querySelector('.product__images');

  const setBtnPositionTop = () => {
    const screenWidth = window.innerWidth;
    const firstSlide = document.querySelector('.product__slides .product__slide');
    const gallery = getGalleryContainer();
    const widget =
      gallery?.querySelector('.model-fit-wrapper') ??
      document.querySelector('.model-fit-wrapper');

    if (!firstSlide || !widget) return;

    const heightFirst = firstSlide.clientHeight;

    if (screenWidth < 768) {
      widget.style.top = `${heightFirst - 45}px`;
    } else {
      widget.style.top = `${heightFirst - 42}px`;
    }
  };

  const storeWrappers = () => {
    const candidates = [...document.querySelectorAll('.model-fit-wrapper')];
    const ids = new Set(
      candidates.map((w) => w.dataset.id).filter(Boolean),
    );

    wrappersMap.clear();

    for (const id of ids) {
      const matching = candidates.filter((w) => w.dataset.id === id);
      const outsideGallery = matching.find((w) => !w.closest('.product__images'));
      const chosen = outsideGallery ?? matching.at(-1);
      if (chosen) {
        wrappersMap.set(id, chosen);
      }
    }
  };

  const restoreWrappers = () => {
    const galleryContainer = getGalleryContainer();
    if (!galleryContainer) return;

    wrappersMap.forEach((wrapper, id) => {
      galleryContainer.querySelectorAll('.model-fit-wrapper').forEach((node) => {
        if (node.dataset.id === id && node !== wrapper) {
          node.remove();
        }
      });

      if (!galleryContainer.contains(wrapper)) {
        galleryContainer.insertBefore(wrapper, galleryContainer.firstChild);
      }
      wrapper.style.display = 'block';
      setBtnPositionTop();
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.model-fit-trigger');

    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const wrapper = btn.closest('.model-fit-wrapper');

    wrapper?.classList.toggle('is-active');
  });

  storeWrappers();
  restoreWrappers();

  const observer = new MutationObserver(() => {
    storeWrappers();
    restoreWrappers();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('resize', () => {
    setBtnPositionTop();
  });
});